export default __webpack_public_path__ + "static/image6-63a67f4f0f36816fab3f803a7ee1b3ad.jpg";